module.exports = __webpack_public_path__ + "onboarding-cef26653cb653f1871d861b58abdf115.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/customer_projects_list/onboarding.png
// module id = 1451
// module chunks = 4 5